export default __webpack_public_path__ + "static/media/logo.1dc134c1.png";